import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ArrowCardToggle from "../../../utils/components/ArrowCardToggle";

import "../../../../styles/components/legal/Legal.scss";

class Privacy extends Component {
  state = {};
  render() {
    return (
      <div id="privacy">
        <div className="privacy-text">
          <Translate value="legalPrivacy_text" />
        </div>
        <Accordion>
          <Card>
            <ArrowCardToggle eventKey="0">
              <Translate value="legalPrivacy_dataCollectionTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Translate value="legalPrivacy_dataCollectionText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ArrowCardToggle eventKey="1">
              <Translate value="legalPrivacy_privacyControlsTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <Translate value="legalPrivacy_privacyControlsText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ArrowCardToggle eventKey="2">
              <Translate value="legalPrivacy_sharingInfoTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <Translate value="legalPrivacy_sharingInfoText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ArrowCardToggle eventKey="3">
              <Translate value="legalPrivacy_keepingInfoSecureTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <Translate value="legalPrivacy_keepingInfoSecureText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default Privacy;
